import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: BASE ? `${BASE}/api` : undefined, withCredentials: true });

// Staff access tokens are short-lived: on a 401 from an admin call, refresh once and retry.
let refreshing = null;
api.interceptors.response.use(undefined, async (error) => {
  const cfg = error?.config;
  const url = cfg?.url ?? "";
  if (error?.response?.status !== 401 || !cfg || cfg._retried || !url.startsWith("/admin")) return Promise.reject(error);
  cfg._retried = true;
  try {
    refreshing = refreshing ?? api.post("/auth/refresh").finally(() => { refreshing = null; });
    await refreshing;
    return api(cfg);
  } catch {
    return Promise.reject(error);
  }
});

export const apiReady = Boolean(BASE);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (typeof e?.msg === "string" ? e.msg.replace(/^Value error, /, "") : "")).filter(Boolean).join(" ");
  return typeof detail?.msg === "string" ? detail.msg : "Something went wrong. Please try again.";
}

// Random idempotency key so retries / double-clicks never create duplicates.
export const newId = () =>
  (typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID()
    : Array.from({ length: 4 }, () => Math.random().toString(16).slice(2, 10)).join("-"));

// The backend discards submissions made faster than a person could type (bot defence). A very quick human
// shouldn't be silently discarded, so wait out the remainder before sending.
export const humanPause = (startedAt) =>
  new Promise((resolve) => { setTimeout(resolve, Math.max(0, 2700 - (Date.now() - startedAt))); });


